<script setup lang="ts">
const songStore = useSongStore();
const store = useMediaPlayerStore();
</script>

<template>
  <Transition name="fade">
    <div
      v-if="!songStore.loading"
      id="MediaPlayer"
    >
      <SlideTransition :show="!!store.nowPlaying">
        <NowPlayingFull />
      </SlideTransition>
      <div class="media-list">
        <MediaPlayerStickyList />
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="postcss">
#MediaPlayer {
  @apply rounded-xl bg-black bg-opacity-25;
}
.media-list {
  @apply p-5 pb-1;
}
</style>
